(() => {
  const readCollectionInfoCards = () => {
    const isCollectioninfoCardsEnabled = window._growthbook.getFeatureValue(
      "pdm-silverts-plp-info-cards",
      false,
    );

    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-silverts",
      "OFF",
    );

    if (!isCollectioninfoCardsEnabled || holdoutGroup === "holdout-q4-2025") {
      return;
    }

    document.body.setAttribute("data-pdm-info-cards", "true");
  };

	const readStickyATC = () => {
    const isCollectioninfoCardsEnabled = window._growthbook.getFeatureValue(
      "pdm-silverts-sticky-atc",
      false
    );

    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-silverts",
      "OFF"
    );

    if (!isCollectioninfoCardsEnabled || holdoutGroup === "holdout-q4-2025") {
      return;
    }

    document.body.setAttribute("data-sticky-cta", "true");
  };

  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push((gb) => {
    const applyFeatureFlags = () => {
      readCollectionInfoCards();
      readStickyATC();
    };

    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
})();
